"use client";

import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { getInitials } from "@workspace/ui/lib/initials";
import { cn } from "@workspace/ui/lib/utils";
import type { ComponentProps } from "react";

function Avatar({
  className,
  ...props
}: ComponentProps<typeof AvatarPrimitive.Root>) {
  return (
    <AvatarPrimitive.Root
      className={cn(
        "relative flex size-8 shrink-0 overflow-hidden rounded-full",
        className
      )}
      data-slot="avatar"
      {...props}
    />
  );
}

// react-doctor-disable-next-line react-doctor/no-multi-comp -- shadcn/ui registry file — multiple components per file is the documented pattern for npx shadcn add
function AvatarImage({
  className,
  ...props
}: ComponentProps<typeof AvatarPrimitive.Image>) {
  return (
    <AvatarPrimitive.Image
      className={cn("aspect-square size-full object-cover", className)}
      data-slot="avatar-image"
      {...props}
    />
  );
}

// react-doctor-disable-next-line react-doctor/no-multi-comp -- shadcn/ui registry file — multiple components per file is the documented pattern for npx shadcn add
function AvatarFallback({
  className,
  ...props
}: ComponentProps<typeof AvatarPrimitive.Fallback>) {
  return (
    <AvatarPrimitive.Fallback
      className={cn(
        "flex size-full items-center justify-center rounded-full bg-muted",
        className
      )}
      data-slot="avatar-fallback"
      {...props}
    />
  );
}

function InitialsAvatarFallback({
  className,
  name,
  ...props
}: ComponentProps<typeof AvatarPrimitive.Fallback> & { name: string }) {
  return (
    <AvatarFallback className={className} {...props}>
      <span className="font-medium text-xs">{getInitials(name)}</span>
    </AvatarFallback>
  );
}

export {
  Avatar,
  AvatarImage,
  AvatarFallback,
  InitialsAvatarFallback,
  getInitials,
};
